import type { StaffAlert } from "./use-staff-step12";
export type StaffAlertDisplay=StaffAlert&{sourceIds?:string[]};
export function cairoAlertDay(iso:string){return new Intl.DateTimeFormat("en-CA",{timeZone:"Africa/Cairo",year:"numeric",month:"2-digit",day:"2-digit"}).format(new Date(iso))}
/** Authorized results only: filter first for visible rows; use all for inbox counts. */
export function groupMissingPaperAlerts(alerts:StaffAlert[]):StaffAlertDisplay[]{
  const rows:StaffAlertDisplay[]=[],byDay=new Map<string,StaffAlertDisplay>();
  for(const a of alerts){
    if(a.kind!=="missing_papers"){rows.push(a);continue}
    const day=cairoAlertDay(a.createdAt),person={employeeId:a.employeeId,employeeName:a.employeeName,employeeNameAr:a.employeeNameAr,missingKinds:a.payload.missingKinds||[]};
    const group=byDay.get(day);
    if(group){
      group.sourceIds!.push(a.id);group.payload.missingPeople!.push(person);
      if(!a.readAt)group.readAt=null;
      if(a.branchId!==group.branchId){group.branchId="";group.branchName=""}
      if(a.createdAt>group.createdAt)group.createdAt=a.createdAt;
    }else{
      const next:StaffAlertDisplay={...a,id:`missing-papers:${day}`,employeeId:null,sourceIds:[a.id],payload:{...a.payload,missingPeople:[person]}};
      byDay.set(day,next);rows.push(next);
    }
  }
  return rows.sort((a,b)=>b.createdAt.localeCompare(a.createdAt));
}
/** Whole authorized inbox count; never pass the current UI-filtered subset. */
export function staffUnreadAlertRows(alerts:StaffAlert[]){
  return groupMissingPaperAlerts(alerts).filter(alert=>!alert.readAt).length;
}
